module.exports = __webpack_public_path__ + "static/img/banner.933522e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/banner.jpg
// module id = WIZl
// module chunks = 0